/**
 * Single source for service worker script URL / registration options and for
 * the cache naming used inside the webpack-generated service-worker.js.
 * Production JS/CSS use content-hashed filenames; the SW uses cache-first for
 * same-origin assets (aligned with KivuIMSUIContainerApp).
 */

export type ServiceWorkerAppConfig = {
  scriptPath: string;
  registrationScope: string;
  updateViaCache: "none";
  cacheNamePrefix: string;
  indexHtmlFallback: string;
};

export const SERVICE_WORKER_CONFIG: ServiceWorkerAppConfig = {
  scriptPath: "/service-worker.js",
  registrationScope: "/",
  updateViaCache: "none",
  cacheNamePrefix: "kivunova-website-",
  indexHtmlFallback: "/index.html"
};
